import React, { JSXElementConstructor } from 'react';
import { log } from './log';

function withErrorLog<P>(WrappedComponent: JSXElementConstructor<P>) {
    class WithErrorLog extends React.Component<P> {
        componentDidCatch(error, errorInfo) {
            log.error(error, errorInfo);
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    }

    (WithErrorLog as any).displayName = `withErrorLog(${getDisplayName(WrappedComponent)})`;
    return WithErrorLog;
}

function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export default withErrorLog;
